function collectFromPanelRows(panelRows: unknown, out: Set<number>): void {
  if (!Array.isArray(panelRows)) return
  for (const row of panelRows) {
    if (!Array.isArray(row)) continue
    for (const cell of row) {
      if (!cell || typeof cell !== 'object') continue
      const panelId = Number((cell as { panelId?: unknown }).panelId)
      if (Number.isFinite(panelId) && panelId > 0) {
        out.add(panelId)
      }
    }
  }
}

function collectFromRegion(region: unknown, out: Set<number>): void {
  if (!Array.isArray(region)) return
  for (const band of region) {
    if (!Array.isArray(band)) continue
    for (const tab of band) {
      if (!tab || typeof tab !== 'object') continue
      collectFromPanelRows((tab as { panelRows?: unknown }).panelRows, out)
    }
  }
}

/** panelId из main/header/footer после parseService.getForm. */
export function collectLayoutPanelIds(formLike: unknown): number[] {
  if (!formLike || typeof formLike !== 'object') {
    return []
  }
  const form = formLike as Record<string, unknown>
  const ids = new Set<number>()
  for (const key of ['main', 'header', 'footer'] as const) {
    collectFromRegion(form[key], ids)
  }
  return [...ids]
}
